<template>
    <div class="serviceRating">
        <ul class="flowerlist">
            <li v-for="item in itemClasses" :class="item"></li>
        </ul>
    </div>
</template>

<script>

    /**
     * 实心花 SOLID_FLOWER
     * 空心花 HOLLOW_FLOWER
     */

    const SOLID_FLOWER="solid";
    const HOLLOW_FLOWER="hollow";

    export default {
        name: "serviceRating",
        data(){
            return {

            }
        },
        props:{
            score:{
                type:Number,
                default:0
            }
        },

        methods:{},
        computed:{
            itemClasses(){
                let result=[];
                let solid=parseInt(this.score);
                let hollow=5-solid;
                for(let i=0;i<solid;i++){
                    result.push(SOLID_FLOWER)
                }
                for(let i=0;i<hollow;i++){
                    result.push(HOLLOW_FLOWER)
                }
                return result;
            }
        },
        mounted(){

        }

    }
</script>

<style lang="stylus" scoped>
  @import "~common/stylus/config.styl"
.flowerlist
    display inline-block
    vertical-align middle
    padding-top 3px
    margin-left 6px
    li
        width 24px
        height 24px
        float left
        margin-right -5px
        &.solid
            background-image url(../../assets/images/flower.png)
        &.hollow
            background-image url(../../assets/images/flower_kong.png)
</style>


// WEBPACK FOOTER //
// src/components/service/serviceRating.vue